import { Box, Button, Stack, Typography } from "@mui/material";
import { FC, useCallback } from "react";
import { Colors } from "../../styles/constant";
import CustomPopup from "../CustomPopup/CustomPopup";
import noConnectionImage from "../../assets/images/no-connection.webp";
import {
  blockedUserDefaultMessage,
  blockedUserDefaultTitleMessage,
} from "../../utils/constants";
import useCmsPageVariables from "../../hooks/useCmsPageVariables";

type CustomBlockUserPopupProps = {
  open: boolean;
  handleOpen: Function;
};

const CustomBlockUserPopup: FC<CustomBlockUserPopupProps> = ({
  open = false,
  handleOpen,
}) => {
  const blockedUserMessageFromCms = useCmsPageVariables(
    "blocked-user-displayMessage",
  );

  const handleClosePopup = useCallback(() => {
    handleOpen(false);
  }, [handleOpen]);

  return (
    <CustomPopup handleOpen={handleClosePopup} open={open}>
      <Box padding="1.5rem 1rem">
        <Box display="flex" justifyContent="center">
          <img
            src={noConnectionImage}
            alt="no-connection"
            style={{ width: "12.25rem", height: "12.25rem" }}
          />
        </Box>
        <Box marginTop="1.5rem">
          <Typography textAlign="center" variant="h3">
            {blockedUserMessageFromCms?.attributes?.title ||
              blockedUserDefaultTitleMessage}
          </Typography>
          <Typography
            marginTop="1rem"
            textAlign="center"
            variant="h5"
            paddingX="1.25rem"
            color={Colors.textGray}
          >
            {blockedUserMessageFromCms?.attributes?.text ||
              blockedUserDefaultMessage}
          </Typography>
        </Box>
        <Stack direction={"row"}>
          <Button
            fullWidth
            variant="contained"
            sx={{ margin: " 1rem .25rem .25rem  .25rem" }}
            onClick={handleClosePopup}
          >
            Close
          </Button>
        </Stack>
      </Box>
    </CustomPopup>
  );
};

export default CustomBlockUserPopup;
